import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function CreateCycle (){
  const {user} = useUser()
  let view = contentLayout[modules.CreateCycle]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CreateCycle.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CreateCycle}></Index>
 )
}

export default CreateCycle
